export const REPORTS_EXPORT_HISTORY_REQUEST = "REPORTS_EXPORT_HISTORY_REQUEST";
export const REPORTS_EXPORT_HISTORY_RESULT = "REPORTS_EXPORT_HISTORY_RESULT";
export const REPORTS_EXPORT_HISTORY_REFRESH_EXPORT_LOG_URL_REQUEST = "REPORTS_EXPORT_HISTORY_REFRESH_EXPORT_LOG_URL_REQUEST";
export const REPORTS_EXPORT_HISTORY_REFRESH_EXPORT_LOG_URL_RESULT = "REPORTS_EXPORT_HISTORY_REFRESH_EXPORT_LOG_URL_RESULT";
